import { Dialog, DialogTitle, DialogActions, DialogContent } from "@mui/material";
import React from "react";

export default function ConfirmDialog(props: any) {
  const { title, children, open, setOpen, onConfirm } = props;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="confirm-dialog">
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <button
          className="button" // no itx
          id="ConfirmDialog_abort" // no itx
          onClick={() => setOpen(false)}
        >
          {state.translate("no", "No")}
        </button>
        <button
          className="button" // no itx
          id="ConfirmDialog_confirm" // no itx
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
        >
          {state.translate("yes", "Yes")}
        </button>
      </DialogActions>
    </Dialog>
  );
}

